<template>
  <div
    class="tender-list-cell tender-list-cell_value tender-list-cell_value-vertical"
    :class="{
      'tender-list-cell_success': getTableValue(index, row, 'is_min_price') && needGreenBacklight,
    }"
  >
    <div v-if="!row.row.group_level" class="d-contents">
      <v-skeleton-loader v-if="tenderListsInfoLoading" type="text" width="50" />
      <div v-else class="d-contents">
        <div class="tender-list-cell_currency spacex-4">
          <template v-if="isValueShown">
            <div class="table-cell-currency">
              {{ currencySymbols[currency] }}
            </div>
            <div>{{ cellValue }}</div>
          </template>
          <div v-else>—</div>
        </div>
        <span v-if="percentValue" class="tender-list-cell_percent-value">
          +{{ percentValue }}%
        </span>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import { VSkeletonLoader } from 'vuetify/lib';
  import addSpaces from '@/utils/formatting/add-spaces';

  export default {
    name: 'TenderListCell',
    components: {
      VSkeletonLoader,
    },
    props: {
      currency: {
        type: String,
        required: true,
      },
      field: {
        type: String,
        required: true,
      },
      index: {
        type: Number,
        required: true,
      },
      row: {
        type: Object,
        required: true,
      },
      offers: {
        type: Array,
        required: true,
      },
      selectedVersions: {
        type: Object,
        required: true,
      },
      percentField: {
        type: String,
        default: '',
      },
      needGreenBacklight: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      ...mapState('tender', ['tenderListsInfoLoading']),
      ...mapState('global', ['currencySymbols']),
      percentValue() {
        return this.getTableValue(this.index, this.row, this.percentField);
      },
      cellValue() {
        return this.getTableValue(this.index, this.row, this.field, true);
      },
      isValueShown() {
        return !!parseInt(this.cellValue);
      },
    },
    methods: {
      addSpaces,
      getTableValue(index, row, field, getFixedNumber) {
        const offer = this.offers?.[index];
        const offerId = offer.id;
        // Берем выбранную версию, иначе последнюю, при возможных ошибках нулевой индекс
        const versionIndex = this.selectedVersions?.[offerId]?.versionIndex;
        const versionsLength = offer?.versions?.length;
        const selectedVersionIndex =
          versionIndex !== undefined ? versionIndex : versionsLength ? versionsLength - 1 : 0;
        const versionId = this.offers[index]?.versions[selectedVersionIndex].id;
        if (getFixedNumber && Number.isFinite(+row?.offer_rows[versionId]?.[field])) {
          const value = +row?.offer_rows[versionId]?.[field];
          return this.addSpaces(value);
        }
        return row?.offer_rows[versionId]?.[field] || '';
      },
    },
  };
</script>
